import {TooltipWithBounds} from '@visx/tooltip';
import React from 'react';

import {formatArtifactVersionMetricValue} from './artifactVersionMetricChartFormatting';
import type {ArtifactVersionMetricChartRow} from './types';

const TOOLTIP_STYLE = {backgroundColor: 'transparent'} as const;

type ArtifactVersionMetricTooltipProps = {
  left?: number;
  metricName?: string;
  row: ArtifactVersionMetricChartRow;
  top?: number;
};

export const ArtifactVersionMetricTooltip: React.FC<
  ArtifactVersionMetricTooltipProps
> = ({left, metricName, row, top}) => {
  const valueTitle =
    metricName != null && metricName !== '' ? metricName : 'Value';

  return (
    <TooltipWithBounds
      key={`${row.membershipId}-${left ?? 0}-${top ?? 0}`}
      className="rv-hint z-[2]"
      left={left}
      top={top}
      style={TOOLTIP_STYLE}>
      <div className="whitespace-nowrap rounded border border-wb-border bg-wb-surface px-8 py-6 text-xs leading-[150%] text-wb-text-secondary shadow-none dark:border-moon-700 dark:bg-moon-900 dark:text-moon-200">
        <div>
          <strong>Version:</strong> {row.label}
        </div>
        <div>
          <strong>{valueTitle}:</strong>{' '}
          {formatArtifactVersionMetricValue(row.value)}
        </div>
        {row.sourceRunName != null && row.sourceRunName !== '' && (
          <div>
            <strong>Source run:</strong> {row.sourceRunName}
          </div>
        )}
        {row.sourceProjectName != null && row.sourceProjectName !== '' && (
          <div>
            <strong>Source project:</strong> {row.sourceProjectName}
          </div>
        )}
        {row.historyStep != null && (
          <div>
            <strong>History step:</strong> {row.historyStep}
          </div>
        )}
      </div>
    </TooltipWithBounds>
  );
};
